import { render, staticRenderFns } from "./DownloadTrafficReport.vue?vue&type=template&id=a42c1faa&scoped=true&"
import script from "./DownloadTrafficReport.vue?vue&type=script&lang=js&"
export * from "./DownloadTrafficReport.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTrafficReport.vue?vue&type=style&index=0&id=a42c1faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42c1faa",
  null
  
)

export default component.exports
import {QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInnerLoading,QSpinnerTail,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInnerLoading,QSpinnerTail})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
